<template>
  <span class="pill" :class="`pill--${variant}`"><slot /></span>
</template>

<script setup>
// Atomic pill/badge. Reusable label used for schedule blocks, categories, etc.
//   <TagPill>OPEN</TagPill>            → solid orange
//   <TagPill variant="muted">…</TagPill> → outlined, for dark surfaces
defineProps({
  variant: {
    type: String,
    default: 'solid',
    validator: (v) => ['solid', 'muted', 'light'].includes(v),
  },
})
</script>

<style scoped lang="scss">
.pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: var(--radius-pill);
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  white-space: nowrap;
}

.pill--solid {
  background: var(--hir-orange);
  color: var(--hir-black);
}

.pill--muted {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.25);
}

.pill--light {
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.5);
}
</style>
